module.exports = __webpack_public_path__ + "r-v3/img/ml_56_00.f5936024.jpg";